export const colors = [ '#69C758', '#F7B638', '#69D0FB', '#2096F4', '#F0706F' ]

// const colors2 = [ '#012311', '#08532E', '#16884F', '#26C071', '#39FD94' ]

// const colors3 = [ '#0B2131', '#1B425F', '#2D6790', '#3E8EC5', '#50B8FD' ]

// const colors4 = [ '#3E1415', '#752C3B', '#AA4A6E', '#D96FAE', '#FA9EF7' ]

// const colors5 = [ '#282A01', '#53580C', '#838B19', '#B6C227', '#ECFC36' ]

// const colors6 = [ '#341406', '#602B18', '#904329', '#C45D3B', '#FB794E' ]
